// extracted by mini-css-extract-plugin
export default {"attentionContainer":"style--attentionContainer--88244c","textareaContainer":"style--textareaContainer--d144a0","textarea":"style--textarea--eb2431"};